import AntAPI from './AntAPI';

class AntBadgeStore {
    constructor() {
        this.items = new Map(); // key → { module, table, searchConditions, _sig }
        this.paths = new Map(); // path của badgeRegistry BE → số nơi đang dùng
        this.snapshot = { counts: {}, notification_unread: 0, chat_unread: 0 };
        this.listeners = new Set();
        this.timer = null;
        this.refreshIntervalMs = 2 * 60 * 1000;
        this.pendingFlush = null;
        this.everFetched = false;
        this.inFlight = false;
        this._api = null;
    }

    _getAPI() {
        if (!this._api) this._api = new AntAPI('user', 'ACUserBadge');
        return this._api;
    }

    registerItems(items) {
        if (!(items instanceof Array)) return;
        var changed = false;
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            if (!it || !it.key || !it.module || !it.table) continue;
            var sig = JSON.stringify(it.searchConditions || {});
            var existing = this.items.get(it.key);
            if (!existing || existing.module !== it.module || existing.table !== it.table || existing._sig !== sig) {
                this.items.set(it.key, {
                    module: it.module,
                    table: it.table,
                    searchConditions: it.searchConditions || {},
                    _sig: sig
                });
                changed = true;
            }
        }
        if (changed) this._scheduleRefresh();
    }

    unregisterItems(keys) {
        if (!(keys instanceof Array)) return;
        for (var i = 0; i < keys.length; i++) this.items.delete(keys[i]);
    }

    // Khoá đọc thẳng từ badgeRegistry BE (không kèm bảng/điều kiện).
    registerPaths(paths) {
        if (!(paths instanceof Array)) return;
        var changed = false;
        for (var i = 0; i < paths.length; i++) {
            var p = paths[i];
            if (typeof p !== 'string' || !p) continue;
            var n = this.paths.get(p) || 0;
            if (!n) changed = true;
            this.paths.set(p, n + 1);
        }
        if (changed) this._scheduleRefresh();
    }

    unregisterPaths(paths) {
        if (!(paths instanceof Array)) return;
        for (var i = 0; i < paths.length; i++) {
            var n = this.paths.get(paths[i]) || 0;
            if (n <= 1) this.paths.delete(paths[i]);
            else this.paths.set(paths[i], n - 1);
        }
    }

    _scheduleRefresh() {
        if (this.pendingFlush) return;
        var that = this;
        this.pendingFlush = setTimeout(function () {
            that.pendingFlush = null;
            that.refresh();
        }, 50);
    }

    subscribe(fn) {
        this.listeners.add(fn);
        this._startTimer();
        if (this.everFetched) {
            try { fn(this.snapshot); } catch (e) {}
        } else {
            this._scheduleRefresh();
        }
        var that = this;
        return function () {
            that.listeners.delete(fn);
            if (that.listeners.size === 0) that._stopTimer();
        };
    }

    _startTimer() {
        if (this.timer) return;
        var that = this;
        // Tab ẩn thì bỏ nhịp: thực đơn tự gọi lại khi cửa sổ được focus.
        this.timer = setInterval(function () {
            if (typeof document !== 'undefined' && document.hidden) return;
            that.refresh();
        }, this.refreshIntervalMs);
    }

    _stopTimer() {
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    getSnapshot() { return this.snapshot; }

    refresh() {
        if (this.inFlight) return;
        this.inFlight = true;
        var that = this;
        var items = [];
        var paths = [];
        this.items.forEach(function (v, key) {
            items.push({ key: key, module: v.module, table: v.table, searchConditions: v.searchConditions });
            paths.push(key);
        });
        this.paths.forEach(function (n, path) {
            if (paths.indexOf(path) < 0) paths.push(path);
        });
        try {
            var api = this._getAPI();
            // BE chỉ đếm các path được xin; thiếu `paths` thì BE đếm đủ registry.
            api.post('/' + api.routeURL + '/batch', { items: items, paths: paths }, function (res) {
                that.inFlight = false;
                var data = (res && res.data) || res || {};
                that.snapshot = {
                    counts: data.counts || {},
                    notification_unread: data.notification_unread || 0,
                    chat_unread: data.chat_unread || 0
                };
                that.everFetched = true;
                that.listeners.forEach(function (fn) { try { fn(that.snapshot); } catch (e) {} });
            });
        } catch (e) {
            this.inFlight = false;
        }
    }

    invalidate() { this.refresh(); }

    reset() {
        this.items.clear();
        this.paths.clear();
        this.snapshot = { counts: {}, notification_unread: 0, chat_unread: 0 };
        this.everFetched = false;
    }
}

const instance = new AntBadgeStore();
if (typeof window !== 'undefined') window.AntBadgeStore = instance;
export default instance;
